document.addEventListener("DOMContentLoaded", function() {
    // Tableau de mots-clés et de leurs URLs correspondantes
    const motsClesEtUrls = {
      "maca": "/products/maca-bio",
      "curcuma": "/products/curcuma-bio",
      "complément alimentaire": "/collections/complements-alimentaires-naturels",
      "complément alimentaire articulation": "/collections/complements-alimentaires-os-et-articulations",
      "complément alimentaire circulation sanguine": "/collections/circulation-cardiovasculaire",
      "complément alimentaire confort du quotidien": "/collections/confort-du-quotidien",
      "complément alimentaire confort feminin": "/collections/confort-feminin",
      "complément alimentaire ménopause": "/collections/complement-alimentaire-menopause",
      "complément alimentaire confort masculin": "/collections/confort-masculin",
      "complément alimentaire immunité": "/collections/immunite-et-antioxydant",
      "complément alimentaire détox": "/collections/detox",
      "complément alimentaire digestion": "/collections/digestion-transit",
      "complément alimentaire minceur": "/collections/draineur-minceur",
      "complément alimentaire aphrodisiaque": "/collections/sexualite-aphrodisiaque",
      "complément alimentaire sommeil": "/collections/stress-sommeil",
      "complément alimentaire vision": "/collections/vision-cerveau",
      "complément alimentaire vitalité": "/collections/vitalite",
      "complément alimentaire vitamines": "/collections/vitamines-mineraux",
      "complément alimentaire grossesse": "/collections/grossesse",
      "complément alimentaire étudiant": "/collections/etudiant",
      "complément alimentaire sportif": "/collections/sportif",
      "superaliment": "/collections/superaliments",
      "poudre de plantes": "/collections/poudres-de-plantes",
      "gemmothérapie": "/collections/gemmotherapie",
      "tisane": "/collections/infusion-et-thes-naturels",
      "plantes en vrac": "/collections/plantes-en-vrac",
      "rhum arrangé": "/collections/preparation-rhum-arrange",
      "cosmétique": "/collections/cosmetique-bien-etre",
      "huile essentielle": "/collections/huiles-essentielles",
      "détoxifier son organisme": "/collections/detoxifier-mon-organisme",
      "nuits paisibles": "/collections/passer-des-nuits-paisibles",
      "confort digestif": "/collections/retrouver-du-confort-digestif",
      "booster mon metabolisme": "/collections/booster-mon-metabolisme",
      "me détendre": "/collections/me-detendre",
      "soulager de la ménopause": "/collections/me-soulager-de-la-menopause",
	  "superaliments": "/collections/superaliments",
      "aliments riches en nutriments": "/collections/superaliments",
      "produits de santé naturels": "/collections/superaliments",
      "boosters de santé": "/collections/superaliments",
      "nutrition et bien-être": "/collections/superaliments",
      "produits énergétiques naturels": "/collections/superaliments",
      "alimentation saine": "/collections/superaliments",
      "superfoods en ligne": "/collections/superaliments",
      "bio et superaliments": "/collections/superaliments",
	  "poudres de plantes médicinales": "/collections/poudres-de-plantes",
      "compléments en poudre naturels": "/collections/poudres-de-plantes",
      "remèdes naturels en poudre": "/collections/poudres-de-plantes",
      "plantes séchées en poudre": "/collections/poudres-de-plantes",
      "suppléments à base de plantes": "/collections/poudres-de-plantes",
      "nutrition à base de plantes": "/collections/poudres-de-plantes",
	  "gemmothérapie": "/collections/gemmotherapie",
      "remèdes à base de bourgeons": "/collections/gemmotherapie",
      "extraits de bourgeons": "/collections/gemmotherapie",
      "plantes en gemmothérapie": "/collections/gemmotherapie",
      "thérapie par les bourgeons": "/collections/gemmotherapie",
      "soins naturels en gemmothérapie": "/collections/gemmotherapie",
      "bourgeons de plantes": "/collections/gemmotherapie",
      "extraits végétaux de bourgeons": "/collections/gemmotherapie",
      "suppléments de gemmothérapie": "/collections/gemmotherapie",
      "produits naturels à base de bourgeons": "/collections/gemmotherapie",
	  "infusions naturelles": "/collections/infusion-et-thes-naturels",
      "thés naturels": "/collections/infusion-et-thes-naturels",
      "infusions bien-être": "/collections/infusion-et-thes-naturels",
      "tisanes de plantes": "/collections/infusion-et-thes-naturels",
      "boissons santé naturelles": "/collections/infusion-et-thes-naturels",
      "thés et infusions bio": "/collections/infusion-et-thes-naturels",
      "tisanes naturelles": "/collections/infusion-et-thes-naturels",
      "infusions de plantes": "/collections/infusion-et-thes-naturels",
      "mélanges de thés naturels": "/collections/infusion-et-thes-naturels",
	  "plantes en vrac": "/collections/plantes-en-vrac",
      "herbes en vrac": "/collections/plantes-en-vrac",
      "plantes médicinales en vrac": "/collections/plantes-en-vrac",
      "herbes médicinales en vrac": "/collections/plantes-en-vrac",
      "plantes sèches en vrac": "/collections/plantes-en-vrac",
      "remèdes naturels en vrac": "/collections/plantes-en-vrac",
      "plantes pour infusions en vrac": "/collections/plantes-en-vrac",
      "herbes séchées en vrac": "/collections/plantes-en-vrac",
      "plantes pour tisanes en vrac": "/collections/plantes-en-vrac",
      "suppléments de plantes en vrac": "/collections/plantes-en-vrac",
	  "préparation rhum arrangé": "/collections/preparation-rhum-arrange",
      "épices pour rhum arrangé": "/collections/preparation-rhum-arrange",
      "mélange rhum arrangé": "/collections/preparation-rhum-arrange",
      "ingrédients pour rhum arrangé": "/collections/preparation-rhum-arrange",
      "kit rhum arrangé": "/collections/preparation-rhum-arrange",
      "épices traditionnelles pour rhum arrangé": "/collections/preparation-rhum-arrange",
      "boissons préparées pour rhum arrangé": "/collections/preparation-rhum-arrange",
      "préparation de cocktails": "/collections/preparation-rhum-arrange",
	  "cosmétique bien-être": "/collections/cosmetique-bien-etre",
      "produits de beauté naturels": "/collections/cosmetique-bien-etre",
      "soins de la peau naturels": "/collections/cosmetique-bien-etre",
      "cosmétiques bio": "/collections/cosmetique-bien-etre",
      "produits de soin naturels": "/collections/cosmetique-bien-etre",
      "cosmétiques naturels": "/collections/cosmetique-bien-etre",
      "bien-être au naturel": "/collections/cosmetique-bien-etre",
      "soins corporels naturels": "/collections/cosmetique-bien-etre",
      "beauté au naturel": "/collections/cosmetique-bien-etre",
      "produits de beauté santé": "/collections/cosmetique-bien-etre",
	  "brume d'oreiller": "/collections/brume-doreiller",
      "spray d'ambiance": "/collections/brume-doreiller",
      "brume relaxante": "/collections/brume-doreiller",
      "parfum d'oreiller": "/collections/brume-doreiller",
      "aromathérapie pour sommeil": "/collections/brume-doreiller",
      "spray détente": "/collections/brume-doreiller",
      "spray de relaxation": "/collections/brume-doreiller",
	  "huiles essentielles": "/collections/huiles-essentielles",
      "huiles aromatiques": "/collections/huiles-essentielles",
      "essences naturelles": "/collections/huiles-essentielles",
      "huiles thérapeutiques": "/collections/huiles-essentielles",
      "produits pour aromathérapie": "/collections/huiles-essentielles",
      "huiles pour bien-être": "/collections/huiles-essentielles",
	  "compléments alimentaires naturels": "/collections/complements-alimentaires-naturels",
      "suppléments nutritionnels": "/collections/complements-alimentaires-naturels",
      "produits de santé naturels": "/collections/complements-alimentaires-naturels",
      "formules naturelles": "/collections/complements-alimentaires-naturels",
      "compléments pour bien-être": "/collections/complements-alimentaires-naturels",
      "soutien nutritionnel naturel": "/collections/complements-alimentaires-naturels",
	  "compléments alimentaires os et articulations": "/collections/complements-alimentaires-os-et-articulations",
      "suppléments pour la santé osseuse": "/collections/complements-alimentaires-os-et-articulations",
      "produits pour articulations": "/collections/complements-alimentaires-os-et-articulations",
      "vitamines pour os et articulations": "/collections/complements-alimentaires-os-et-articulations",
      "renforcement osseux": "/collections/complements-alimentaires-os-et-articulations",
      "soutien articulaire naturel": "/collections/complements-alimentaires-os-et-articulations",
      "compléments pour flexibilité": "/collections/complements-alimentaires-os-et-articulations",
      "formules pour santé des os": "/collections/complements-alimentaires-os-et-articulations",
      "produits pour maintien de la mobilité": "/collections/complements-alimentaires-os-et-articulations",
	  "circulation cardiovasculaire": "/collections/circulation-cardiovasculaire",
      "compléments pour santé cardiovasculaire": "/collections/circulation-cardiovasculaire",
      "support circulatoire naturel": "/collections/circulation-cardiovasculaire",
      "suppléments pour coeur et circulation": "/collections/circulation-cardiovasculaire",
      "vitamines pour système cardiovasculaire": "/collections/circulation-cardiovasculaire",
      "formules pour santé cardiaque": "/collections/circulation-cardiovasculaire",
      "soutien vasculaire naturel": "/collections/circulation-cardiovasculaire",
      "produits pour santé du coeur": "/collections/circulation-cardiovasculaire",
      "boosters de circulation": "/collections/circulation-cardiovasculaire",
	  "confort quotidien": "/collections/confort-du-quotidien",
      "compléments pour bien-être quotidien": "/collections/confort-du-quotidien",
      "support santé quotidien": "/collections/confort-du-quotidien",
      "suppléments pour confort physique": "/collections/confort-du-quotidien",
      "vitamines pour bien-être quotidien": "/collections/confort-du-quotidien",
      "formules pour bien-être général": "/collections/confort-du-quotidien",
      "soutien naturel quotidien": "/collections/confort-du-quotidien",
      "produits pour santé et confort": "/collections/confort-du-quotidien",
      "boosters de bien-être quotidien": "/collections/confort-du-quotidien",
      "confort féminin": "/collections/confort-feminin",
      "compléments pour bien-être féminin": "/collections/confort-feminin",
      "support santé féminin": "/collections/confort-feminin",
      "suppléments pour confort hormonal": "/collections/confort-feminin",
	  "vitamines pour confort féminin": "/collections/confort-feminin",
"formules pour bien-être féminin": "/collections/confort-feminin",
"soutien naturel féminin": "/collections/confort-feminin",
"produits pour santé et bien-être féminin": "/collections/confort-feminin",
"boosters de confort féminin": "/collections/confort-feminin",
"compléments alimentaires ménopause": "/collections/complement-alimentaire-menopause",
"suppléments pour symptômes ménopause": "/collections/complement-alimentaire-menopause",
"hormonal ménopause": "/collections/complement-alimentaire-menopause",
"produits pour bien-être ménopause": "/collections/complement-alimentaire-menopause",
"formules naturelles ménopause": "/collections/complement-alimentaire-menopause",
"soutien naturel pour ménopause": "/collections/complement-alimentaire-menopause",
"produits pour confort ménopause": "/collections/complement-alimentaire-menopause",
"boosters pour symptômes ménopause": "/collections/complement-alimentaire-menopause",
"confort masculin": "/collections/confort-masculin",
"compléments pour bien-être masculin": "/collections/confort-masculin",
"santé masculine": "/collections/confort-masculin",
"formules pour bien-être masculin": "/collections/confort-masculin",
"soutien naturel masculin": "/collections/confort-masculin",
"produits pour santé et confort masculin": "/collections/confort-masculin",
"boosters de confort masculin": "/collections/confort-masculin",
"immunité et antioxydants": "/collections/immunite-et-antioxydant",
"compléments pour booster l'immunité": "/collections/immunite-et-antioxydant",
"suppléments antioxydants": "/collections/immunite-et-antioxydant",
"système immunitaire": "/collections/immunite-et-antioxydant",
"vitamines et antioxydants": "/collections/immunite-et-antioxydant",
"formules pour renforcer l'immunité": "/collections/immunite-et-antioxydant",
"soutien naturel immunitaire": "/collections/immunite-et-antioxydant",
"produits pour santé et protection": "/collections/immunite-et-antioxydant",
"boosters de défense immunitaire": "/collections/immunite-et-antioxydant",
"produits détox": "/collections/detox",
"compléments pour détoxification": "/collections/detox",
"suppléments détox": "/collections/detox",
"détox naturel": "/collections/detox",
"vitamines pour détox": "/collections/detox",
"formules de détoxification": "/collections/detox",
"produits pour nettoyer l'organisme": "/collections/detox",
"détoxifiant": "/collections/detox",
"digestion et transit": "/collections/digestion-transit",
"compléments pour digestion": "/collections/digestion-transit",
"transit intestinal": "/collections/digestion-transit",
"digestion naturel": "/collections/digestion-transit",
"améliorer la digestion": "/collections/digestion-transit",
"transit digestif": "/collections/digestion-transit",
"produits pour confort digestif": "/collections/digestion-transit",
"boosters de digestion": "/collections/digestion-transit",
"draineurs minceur": "/collections/draineur-minceur",
"compléments pour minceur": "/collections/draineur-minceur",
"suppléments draineurs": "/collections/draineur-minceur",
"minceur naturel": "/collections/draineur-minceur",
"formules draineur minceur": "/collections/draineur-minceur",
"draineur minceur": "/collections/draineur-minceur",
"perte de poids": "/collections/draineur-minceur",
"sexualité et aphrodisiaques": "/collections/sexualite-aphrodisiaque",
"compléments aphrodisiaques": "/collections/sexualite-aphrodisiaque",
"libido": "/collections/sexualite-aphrodisiaque",
"sexualité naturel": "/collections/sexualite-aphrodisiaque",
"aphrodisiaques naturels": "/collections/sexualite-aphrodisiaque",
"libido naturel": "/collections/sexualite-aphrodisiaque",
"performance sexuelle": "/collections/sexualite-aphrodisiaque",
"boosters de libido": "/collections/sexualite-aphrodisiaque",
"produits stress et sommeil": "/collections/stress-sommeil",
"compléments pour le sommeil": "/collections/stress-sommeil",
"anti-stress": "/collections/stress-sommeil",
"sommeil naturel": "/collections/stress-sommeil",
"soutien naturel contre le stress": "/collections/stress-sommeil",
"produits pour relaxation": "/collections/stress-sommeil",
"vision et cerveau": "/collections/vision-cerveau",
"compléments pour la vision": "/collections/vision-cerveau",
"suppléments pour le cerveau": "/collections/vision-cerveau",
"vision naturel": "/collections/vision-cerveau",
"santé du cerveau": "/collections/vision-cerveau",
"cognitif naturel": "/collections/vision-cerveau",
"acuité visuelle": "/collections/vision-cerveau",
"fonctions cognitives": "/collections/vision-cerveau",
"produits pour la vitalité": "/collections/vitalite",
"compléments pour l'énergie": "/collections/vitalite",
"suppléments vitalité": "/collections/vitalite",
"énergie naturel": "/collections/vitalite",
"formules pour l'énergie": "/collections/vitalite",
"vitalité naturel": "/collections/vitalite",
"augmenter l'énergie": "/collections/vitalite",
"boosters de vitalité": "/collections/vitalite",
"vitamines et minéraux": "/collections/vitamines-mineraux",
"compléments vitaminiques": "/collections/vitamines-mineraux",
"suppléments minéraux": "/collections/vitamines-mineraux",
"support nutritionnel naturel": "/collections/vitamines-mineraux",
"vitamines et minéraux essentiels": "/collections/vitamines-mineraux",
"formules multivitamines": "/collections/vitamines-mineraux",
"carences en vitamines": "/collections/vitamines-mineraux",
"produits pour la grossesse": "/collections/grossesse",
"compléments pour femmes enceintes": "/collections/grossesse",
"suppléments prénataux": "/collections/grossesse",
"support nutritionnel grossesse": "/collections/grossesse",
"vitamines prénatales": "/collections/grossesse",
"soutien naturel pour femmes enceintes": "/collections/grossesse",
"produits pour le bien-être prénatal": "/collections/grossesse",
"boosters de santé pour la grossesse": "/collections/grossesse",
"produits pour les étudiants": "/collections/etudiant",
"compléments pour la concentration": "/collections/etudiant",
"suppléments pour la mémoire": "/collections/etudiant",
"vitamines pour étudiants": "/collections/etudiant",
"formules pour la concentration et la mémoire": "/collections/etudiant",
"soutien cognitif pour étudiants": "/collections/etudiant",
"produits pour le bien-être étudiant": "/collections/etudiant",
"boosters de concentration pour étudiants": "/collections/etudiant",
"produits pour sportifs": "/collections/sportif",
"récupération musculaire": "/collections/sportif",
"support sportif naturel": "/collections/sportif",
"vitamines pour sportifs": "/collections/sportif",
"formules pour l'endurance et la récupération": "/collections/sportif",
"soutien musculaire pour sportifs": "/collections/sportif",
"produits pour le bien-être sportif": "/collections/sportif",
"boosters de performance pour sportifs": "/collections/sportif",
"produits détox": "/collections/detoxifier-mon-organisme",
"compléments détoxifiants": "/collections/detoxifier-mon-organisme",
"suppléments pour nettoyer l'organisme": "/collections/detoxifier-mon-organisme",
"support détox naturel": "/collections/detoxifier-mon-organisme",
"formules pour la purification corporelle": "/collections/detoxifier-mon-organisme",
"soutien naturel pour élimination des toxines": "/collections/detoxifier-mon-organisme",
"produits pour le bien-être détox": "/collections/detoxifier-mon-organisme",
"boosters pour nettoyer l'organisme": "/collections/detoxifier-mon-organisme",
"produits pour le sommeil": "/collections/passer-des-nuits-paisibles",
"compléments pour le sommeil": "/collections/passer-des-nuits-paisibles",
"suppléments pour dormir": "/collections/passer-des-nuits-paisibles",
"support naturel pour le sommeil": "/collections/passer-des-nuits-paisibles",
"vitamines pour un sommeil paisible": "/collections/passer-des-nuits-paisibles",
"formules pour la relaxation nocturne": "/collections/passer-des-nuits-paisibles",
"produits pour digestion": "/collections/retrouver-du-confort-digestif",
"compléments pour confort digestif": "/collections/retrouver-du-confort-digestif",
"suppléments pour digestion facile": "/collections/retrouver-du-confort-digestif",
"support digestif naturel": "/collections/retrouver-du-confort-digestif",
"vitamines pour la digestion": "/collections/retrouver-du-confort-digestif",
"formules pour la santé digestive": "/collections/retrouver-du-confort-digestif",
"confort digestif optimal": "/collections/retrouver-du-confort-digestif",
"produits pour le bien-être digestif": "/collections/retrouver-du-confort-digestif",
"boosters pour une digestion confortable": "/collections/retrouver-du-confort-digestif",
"produits pour métabolisme": "/collections/booster-mon-metabolisme",
"compléments pour métabolisme rapide": "/collections/booster-mon-metabolisme",
"booster le métabolisme": "/collections/booster-mon-metabolisme",
"support naturel pour le métabolisme": "/collections/booster-mon-metabolisme",
"vitamines pour métabolisme rapide": "/collections/booster-mon-metabolisme",
"formules pour booster l'énergie et le métabolisme": "/collections/booster-mon-metabolisme",
"soutien naturel pour un métabolisme optimal": "/collections/booster-mon-metabolisme",
"produits pour le bien-être métabolique": "/collections/booster-mon-metabolisme",
"accélérer le métabolisme": "/collections/booster-mon-metabolisme",
"produits pour relaxation": "/collections/me-detendre",
"compléments pour se détendre": "/collections/me-detendre",
"suppléments pour calmer l'esprit": "/collections/me-detendre",
"support naturel pour la relaxation": "/collections/me-detendre",
"formules pour la tranquillité d'esprit": "/collections/me-detendre",
"soutien naturel pour un bien-être détendu": "/collections/me-detendre",
"produits pour le bien-être mental": "/collections/me-detendre",
"se relaxer": "/collections/me-detendre",
"produits pour ménopause": "/collections/me-soulager-de-la-menopause",
"compléments pour soulager la ménopause": "/collections/me-soulager-de-la-menopause",
"suppléments pour la santé ménopausique": "/collections/me-soulager-de-la-menopause",
"support naturel pour la ménopause": "/collections/me-soulager-de-la-menopause",
"vitamines pour la ménopause": "/collections/me-soulager-de-la-menopause",
"symptômes ménopausiques": "/collections/me-soulager-de-la-menopause",
"soulager les désagréments de la ménopause": "/collections/me-soulager-de-la-menopause",
"soutien naturel pour une ménopause confortable": "/collections/me-soulager-de-la-menopause",
"gérer la ménopause": "/collections/me-soulager-de-la-menopause",
"compléments de collagène marin": "/collections/collagene-marin",
"suppléments pour la peau avec collagène marin": "/collections/collagene-marin",
"support naturel avec collagène marin": "/collections/collagene-marin",
"vitamines avec collagène marin": "/collections/collagene-marin",
"formules pour la peau et les articulations avec collagène marin": "/collections/collagene-marin",
"soutien naturel pour le collagène marin": "/collections/collagene-marin",
"bien-être cutané avec collagène marin": "/collections/collagene-marin",
"revitaliser avec collagène marin": "/collections/collagene-marin",
"compléments de vitamines": "/collections/vitamines",
"suppléments vitaminiques": "/collections/vitamines",
"support naturel avec vitamines": "/collections/vitamines",
"vitamines pour la santé générale": "/collections/vitamines",
"formules vitaminiques": "/collections/vitamines",
"soutien naturel pour les déficits vitaminiques": "/collections/vitamines",
"produits pour le bien-être avec vitamines": "/collections/vitamines",
"produits d'apithérapie": "/collections/apitherapie",
"suppléments à base de produits de la ruche": "/collections/apitherapie",
"support naturel avec apithérapie": "/collections/apitherapie",
"produits pour la santé avec apithérapie": "/collections/apitherapie",
"soutien naturel avec produits de la ruche": "/collections/apitherapie",
"produits pour le bien-être avec produits de la ruche": "/collections/apitherapie",
"vinaigre des 4 voleurs": "/collections/vinaigre-des-4-voleurs",
"support naturel avec vinaigre des 4 voleurs": "/collections/vinaigre-des-4-voleurs",
"produits pour la santé avec le vinaigre des 4 voleurs": "/collections/vinaigre-des-4-voleurs",
"produits d'aloe vera": "/collections/aloe-vera",
"gel d'aloe vera": "/collections/aloe-vera",
"crèmes à l'aloe vera": "/collections/aloe-vera",
"hydratation à l'aloe vera": "/collections/aloe-vera",
"soin naturel à l'aloe vera": "/collections/aloe-vera",
"bienfaits de l'aloe vera": "/collections/aloe-vera",
"utilisations de l'aloe vera": "/collections/aloe-vera",
"soins pour la peau à l'aloe vera": "/collections/aloe-vera",
"elixir du Suédois": "/collections/elixir-du-suedois",
"suppléments élixir du Suédois": "/collections/elixir-du-suedois",
"support naturel avec élixir du Suédois": "/collections/elixir-du-suedois",
"compléments élixir du Suédois": "/collections/elixir-du-suedois",
"produits pour la santé avec élixir du Suédois": "/collections/elixir-du-suedois",
"soutien digestif avec élixir du Suédois": "/collections/elixir-du-suedois",
"bienfaits de l'élixir du Suédois": "/collections/elixir-du-suedois",
"utilisations de l'élixir du Suédois": "/collections/elixir-du-suedois",
"bois bandé": "/collections/bois-bande",
"compléments bois bandé": "/collections/bois-bande",
"suppléments bois bandé": "/collections/bois-bande",
"support naturel avec bois bandé": "/collections/bois-bande",
"thérapie naturelle bois bandé": "/collections/bois-bande",
"soutien énergétique avec bois bandé": "/collections/bois-bande",
"bienfaits du bois bandé": "/collections/bois-bande",
"utilisations du bois bandé": "/collections/bois-bande",
"bois bandé": "/collections/bois-bande",
"bois bande": "/collections/bois-bande",

    };

    // Parcourt tous les paragraphes de la page
    const paragraphs = document.getElementsByTagName('p');

    // Variable pour suivre les mots-clés qui ont déjà été liés
    let motsClesLies = {};

    for (let i = 0; i < paragraphs.length; i++) {
        let paragraph = paragraphs[i];
        
        for (let motCle in motsClesEtUrls) {
            // Vérifie si le mot-clé n'a pas encore été lié sur cette page
            if (!motsClesLies[motCle]) {
                let regex = new RegExp(`\\b(${motCle})\\b`, 'i');
                if (regex.test(paragraph.innerHTML)) {
                    paragraph.innerHTML = paragraph.innerHTML.replace(regex, `<a href="${motsClesEtUrls[motCle]}" title="${motCle}">$1</a>`);
                    motsClesLies[motCle] = true; // Marque ce mot-clé comme lié
                }
            }
        }
    }
});